import { AdminSidebarNavigationItemsList } from 'shared/types';

import { APP_URL } from '.';

export const ADMIN_SIDEBAR_NAVIGATION_ITEMS: AdminSidebarNavigationItemsList = [
  {
    name: 'Dashboard',
    route: APP_URL.admin.dashboard.index,
    icon: 'Dashboard',
  },
  {
    name: 'Community Posts',
    route: APP_URL.admin.posts.index,
    icon: 'Description',
  },
  {
    name: 'Inbox',
    route: APP_URL.admin.mail.index,
    icon: 'MoveToInbox',
  },
  {
    name: 'Content Curation',
    route: APP_URL.admin.contentCuration.index,
    icon: 'Flag',
    showUnreadElements: true,
  },
  {
    name: 'Events',
    route: APP_URL.admin.events.index,
    icon: 'EventNote',
  },
  {
    name: 'Legacy',
    route: APP_URL.admin.legacy.index,
    icon: 'Public',
  },
  {
    name: 'Members',
    route: APP_URL.admin.members.index,
    icon: 'People',
  },
  {
    name: 'Business Registry',
    route: APP_URL.admin.business.index,
    icon: 'Work',
  },
  {
    name: 'Groups',
    route: APP_URL.admin.groups.index,
    icon: 'Groups',
  },
  {
    name: 'Discounts',
    route: APP_URL.admin.discounts.index,
    icon: 'Redeem',
  },
  { name: 'Class Scorecard', route: APP_URL.admin.scorecard.index, icon: 'Equalizer' },
  { name: 'Reports', route: APP_URL.admin.reports.index, icon: 'AutoGraph' },
  {
    name: 'Settings',
    route: APP_URL.admin.settings.index,
    icon: 'Settings',
  },
];
